<template>
  <b-menu>  
    <b-input
      v-model="tagFilter" 
      class="filter-input"
      placeholder="search"
      size="is-small"
    />
    <b-menu-list>
      <b-menu-item  
        v-for="(tag) in tags"
        :key="tag.id"
        :active="selectedTag === tag.name"
        :class="tag.name.toLowerCase().indexOf(tagFilter.toLowerCase()) !==-1 ? &quot;&quot;:&quot;is-hidden&quot;"
        @click="() => $emit('selectedTagChange', tag)"
      >
        <template #label>
          <span class="level">
            <div class="level-left">
              <div
                v-if="tag.id >= 0"
                class="level-item"
              ># {{ tag.name }}</div>
              <div
                v-else
                class="level-item untagged"
              >untagged</div>
            </div>
            <div class="level-right">
              <div class="level-item"><b-tag rounded> {{ tag.bookmarksCount }} </b-tag> </div>
            </div>
          </span>
        </template>
      </b-menu-item>
    </b-menu-list>
  </b-menu>
</template>
  
  <script>

    export default {
      name: 'TagSideBar',
      components: {
      },
      props: {
        selectedTag: {
          type: String,
          default: undefined
        },
        tags: {
          type: Array,
          default: () => { return [];}
        }
      },
      data: function(){
        return {
          tagFilter: ""
        }
      },
      mounted: function(){
      }
    }
  </script>
  
  <style lang="scss" scoped>
    .filter-input{
      padding: 5px;
    }
    .level-item.untagged{
      font-style: italic;
    }
    @media screen and (max-width: 768px) {
      .level {
        display: flex;
      }
      .level-left + .level-right {
          margin-top: 0;
      }
    }
  </style>
   